import Menu from '@mui/material/Menu';
import DownloadIcon from '@mui/icons-material/Download';
import ReplayIcon from '@mui/icons-material/Replay';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import React, { useState } from 'react';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Select, InputLabel, FormControl, MenuItem } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Paper, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Chip, ButtonGroup, Checkbox as MuiCheckbox, FormGroup } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PublishIcon from '@mui/icons-material/Publish';
import AddIcon from '@mui/icons-material/Add';
import { Session } from '../../peer-colab-model/Session';
import { TranslationManagement } from '../../peer-colab-model/PetKey/BackofficeFE/Client/PathItems';
import { useToast } from '../../providers/ToastProvider';
import { Language, TranslationKeyPair } from '../../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Translations/PathItems';
import AISuggestions from '../../components/AISuggestions';
import { SearchTranslationKeysOutput } from '../../peer-colab-model/PetKey/Main/Model/1_0_Initial/PathItems';

const TranslationsView: React.FC = () => {
  // Download dialog state
  const [downloadDialogOpen, setDownloadDialogOpen] = useState(false);
  const [publishedOnly, setPublishedOnly] = useState(true);
  // Dropdown for Publish/Revert All
  const [allAnchorEl, setAllAnchorEl] = useState<null | HTMLElement>(null);
  const allMenuOpen = Boolean(allAnchorEl);
  const defaultSearch = { language1: 'en', language2: 'no', keys: [] }
  const { onError } = useToast()
  const [showMissingLang2, setShowMissingLang2] = useState(false);
  const [translations, setTranslations] = useState<SearchTranslationKeysOutput>(defaultSearch);
  const [editKey, setEditKey] = useState<TranslationKeyPair | null>(null);
  const [newKey, setNewKey] = useState('');
  const [newValues, setNewValues] = useState<{ [lang: string]: string }>({ en: '', no: '' });
  const [languages, setLanguages] = useState<Language[]>([]);
  const [search, setSearch] = useState('');
  const [lang1, setLang1] = useState(defaultSearch.language1);
  const [lang2, setLang2] = useState(defaultSearch.language2);
  const [filterType, setFilterType] = useState<string>('all');
  const lang1InputRef = React.useRef<HTMLInputElement>(null);
  const lang2InputRef = React.useRef<HTMLInputElement>(null);
  const addKeyInputRef = React.useRef<HTMLInputElement>(null);
  const lastEditFocusRef = React.useRef<'lang1' | 'lang2'>('lang2');
  const [stateFilterType, setStateFilterType] = useState<string>('all');
  const [showAddRow, setShowAddRow] = useState(false);
  const [confirmDeleteKey, setConfirmDeleteKey] = useState<string | null>(null);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreResults, setHasMoreResults] = useState(false);

  const searchTranslations = async (query?: string, page?: number, newPageSize?: number, newLang1?: string, newLang2?: string, newMissinglang2?: boolean, newFilterType?: string, newStateType?: string) => {
    const queryString = query !== undefined ? query : search;
    const realPage = page !== undefined ? page : currentPage;
    const realPageSize = newPageSize !== undefined ? newPageSize : pageSize;
    const realLang1 = newLang1 !== undefined ? newLang1 : lang1;
    const realLang2 = newLang2 !== undefined ? newLang2 : lang2;
    const realShowMissingLang2 = newMissinglang2 !== undefined ? newMissinglang2 : showMissingLang2;
    const realFilterType = newFilterType !== undefined ? newFilterType : filterType;
    const realStateType = newStateType !== undefined ? newStateType : stateFilterType;
    onError((await Session.getClient().request(TranslationManagement.searchTranslationKeys({
      searchInput: { query: queryString, limit: realPageSize, offset: (realPage - 1) * realPageSize },
      language1Id: realLang1,
      language2Id: realLang2,
      onlyMissingForLang2: realShowMissingLang2,
      searchType: realFilterType, 
      stateType: realStateType === 'all' ? undefined : realStateType

    }))).maybeOk((value, meta) => {
      setTranslations(value);
      setSearch(queryString);
      setCurrentPage(realPage);
      setPageSize(realPageSize);
      setHasMoreResults(meta.hasMoreValues);
      setLang1(realLang1);
      setLang2(realLang2);
      setShowAddRow(false)
      setShowMissingLang2(realShowMissingLang2)
      setFilterType(realFilterType);
      setStateFilterType(realStateType);
    }))
  }

  React.useEffect(() => {
    const loadLanguagesAndTanslations = async () => {
      onError((await Session.getClient().request(TranslationManagement.getLanguages())).maybeOk(setLanguages));
      await searchTranslations()
    }
    loadLanguagesAndTanslations()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    if (showAddRow && addKeyInputRef.current) {
      setTimeout(() => {
        addKeyInputRef.current && addKeyInputRef.current.focus();
      }, 0);
    }
  }, [showAddRow]);

  React.useEffect(() => {
    if (editKey) {
      if (lastEditFocusRef.current === 'lang1' && lang1InputRef.current) {
        lang1InputRef.current.focus();
      } else if (lang2InputRef.current) {
        lang2InputRef.current.focus();
      }
    }
  }, [editKey]);

  // Publish/Revert All dialog state
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogAction, setDialogAction] = useState<'publish' | 'revert'>('publish');
  const [selectedLanguages, setSelectedLanguages] = useState<string[]>([lang1, lang2]);
  const handlePublishAll = () => {
    setDialogAction('publish');
    setDialogOpen(true);
    setSelectedLanguages([lang1, lang2]);
  };
  const handleRevertAll = () => {
    setDialogAction('revert');
    setDialogOpen(true);
    setSelectedLanguages([lang1, lang2]);
  };
  const handleDialogCancel = () => {
    setDialogOpen(false);
  };
  const handleDialogOk = async () => {
    if (dialogAction === 'publish') {
      onError((await Session.getClient().request(TranslationManagement.publishAllChanges({
        languages: selectedLanguages.length > 0 ? selectedLanguages : undefined,
      }))).maybeOk(() => {
        searchTranslations();
      }))
    } else {
      onError((await Session.getClient().request(TranslationManagement.revertAllChanges({
        languages: selectedLanguages.length > 0 ? selectedLanguages : undefined,
      }))).maybeOk(() => {
        searchTranslations();
      }))
    }
    setDialogOpen(false);
  };
  const handleLanguageToggle = (langId: string) => {
    setSelectedLanguages(prev => prev.includes(langId) ? prev.filter(l => l !== langId) : [...prev, langId]);
  };

  // Handlers
  const handleEdit = (key: TranslationKeyPair) => {
    setEditKey(key);
    setShowAddRow(false)
  };

  const handleEditSave = async () => {
    if (!editKey) return;
    onError((await Session.getClient().request(TranslationManagement.patchTranslation(editKey))).maybeOk(() => {
      const idx = translations.keys.findIndex(t => t.key === editKey.key);
      const updatedTranslations = { ...translations }
      updatedTranslations.keys = updatedTranslations.keys.map((t) => {
        if (t.key === editKey.key) {
          return { ...t, 
            value1: editKey.language1Value.value, 
            value2: editKey.language2Value.value, 
            stateType: 'draft',
           };
        }
        return t;
      });
      setTranslations(updatedTranslations);

      // Find index of current row in filteredTranslations
      if (idx !== -1 && idx < translations.keys.length - 1) {
        const next = translations.keys[idx + 1];
        setEditKey({ key: next.key, language1Value: { languageId: lang1, value: next.value1 }, language2Value: { languageId: lang2, value: next.value2 } });
        // Focus the same field as last time
        setTimeout(() => {
          if (lastEditFocusRef.current === 'lang1' && lang1InputRef.current) {
            lang1InputRef.current.focus();
          } else if (lang2InputRef.current) {
            lang2InputRef.current.focus();
          }
        }, 0);
      } else {
        setEditKey(null);
      }
    }))
  };

  const handleEditCancel = () => {
    setEditKey(null);
  };

  const handleDelete = async (key: string) => {
    onError((await Session.getClient().request(TranslationManagement.deleteTranslationKey(key))).maybeOk(() => {
      const updated = { ...translations }
      updated.keys = updated.keys.filter(t => t.key !== key);
      setTranslations(updated);
    }))
    setConfirmDeleteKey(null);
  };

  const handleAdd = async () => {
    const keyRegex = /^[a-zA-Z0-9.]+$/;
    if (!newKey) {
      return;
    }
    if (!keyRegex.test(newKey)) {
      return;
    }
    if (!newValues['en']) {
      return;
    }
    if (translations.keys.some(t => t.key === newKey)) {
      return;
    }
    onError((await Session.getClient().request(TranslationManagement.createTranslationKey({
      key: newKey,
      language1Value: { languageId: lang1, value: newValues[lang1] || '' },
      language2Value: { languageId: lang2, value: newValues[lang2] || '' },
    }))).maybeOk(() => {
      const updatedTranslations = { ...translations }
      updatedTranslations.keys.unshift({
        key: newKey,
        value1: newValues[lang1] || '',
        value2: newValues[lang2] || '',
        stateType: 'draft',
      });
      setTranslations(updatedTranslations);
      setNewKey('');
      setNewValues({ en: '', no: '' });
      // Refocus key input after adding
      if (addKeyInputRef.current) {
        setTimeout(() => addKeyInputRef.current && addKeyInputRef.current.focus(), 0);
      }
    }))
  };

  const publishChanges = async (key: string) => {
    onError((await Session.getClient().request(TranslationManagement.publishChanges({
      languages: [lang1, lang2],
      keys: [key],
    }))).maybeOk(() => {
      searchTranslations();
    }))
  };

  const revertChanges = async (key: string) => {
    onError((await Session.getClient().request(TranslationManagement.revertChanges({
      languages: [lang1, lang2],
      keys: [key],
    }))).maybeOk(() => {
      searchTranslations();
    }))
  };

  const onDownloadLanguage = async (languageId: string, publishedOnly: boolean) => {
    const result = onError((await Session.getClient().request(TranslationManagement.getLanguageFiles({
      languages: [languageId],
      onlyPublished: publishedOnly
    }))))
    if (!result.success || result.value.length < 1)
      return

    // Trigger a file download of the contents as a JSON file
    const filename = result.value[0].language + '.json';
    const contents = result.value[0].jsonContents;
    const element = document.createElement('a');
    const file = new Blob([contents], { type: 'application/json' });
    element.href = URL.createObjectURL(file);
    element.download = filename;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <Box sx={{ pl: 2, pr: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', verticalAlign: 'middle', gap: 2, mb: 2 }}>
        <h2>Translations</h2>
        <AISuggestions 
          client={Session.getClient()}
          currentSnapshot={JSON.stringify(translations)}
          usageInstructions={TranslationManagement.toAgentInstructions()}
          developerMessage={'The user is in the translations view where they can find translation, add them and edit them. ' +
            'The view is organized in a way that the user can select two languages they want to work with. ' +
            'The translations are used in i18n files and can only contain letters, numbers and dots (.). ' +
            'The dots represents levels in the json generated.'}
          onOperationsApplied={() => searchTranslations(search)}
        />
        <Box sx={{ ml: 'auto' }}>
          <ButtonGroup variant="contained" color="primary">
            <Button onClick={handlePublishAll}>Publish All</Button>
            <Button onClick={e => setAllAnchorEl(e.currentTarget)} sx={{ minWidth: 40 }}>
              <ArrowDropDownIcon />
            </Button>
          </ButtonGroup>
          <Menu
            anchorEl={allAnchorEl}
            open={allMenuOpen}
            onClose={() => setAllAnchorEl(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem onClick={() => { setAllAnchorEl(null); handleRevertAll(); }}>
              <ReplayIcon fontSize="small" sx={{ mr: 1 }} /> Revert All
            </MenuItem>
            <MenuItem onClick={() => { setAllAnchorEl(null); setDownloadDialogOpen(true); }}>
              <DownloadIcon fontSize="small" sx={{ mr: 1 }} /> Download files
            </MenuItem>
          </Menu>
    {/* Download Files Dialog */}
    <Dialog open={downloadDialogOpen} onClose={() => setDownloadDialogOpen(false)}>
      <DialogTitle>Download Translation Files</DialogTitle>
      <DialogContent>
        <FormControlLabel
          control={<Checkbox checked={publishedOnly} onChange={e => setPublishedOnly(e.target.checked)} />}
          label="Published translations only"
          sx={{ mb: 2 }}
        />
        {languages.map(l => (
          <Box key={l.id} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
            <span>{l.name}</span>
            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              onClick={() => onDownloadLanguage(l.id, publishedOnly)}
            >
              Download
            </Button>
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setDownloadDialogOpen(false)} color="primary" variant="contained">Close</Button>
      </DialogActions>
    </Dialog>
        </Box>
      </Box>
    {/* Publish/Revert All Dialog */}
    <Dialog open={dialogOpen} onClose={handleDialogCancel}>
      <DialogTitle>{dialogAction === 'publish' ? 'Publish All Translations' : 'Revert All Translations'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Select the languages to {dialogAction === 'publish' ? 'publish' : 'revert'} for all translation keys:
        </DialogContentText>
        <FormGroup>
          {languages.map(l => (
            <FormControlLabel
              key={l.id}
              control={<MuiCheckbox checked={selectedLanguages.includes(l.id)} onChange={() => handleLanguageToggle(l.id)} />}
              label={l.name}
            />
          ))}
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDialogCancel} color="primary">Cancel</Button>
        <Button onClick={handleDialogOk} color="primary" variant="contained">OK</Button>
      </DialogActions>
    </Dialog>
      <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
        <TextField 
          label="Search" 
          value={search} 
          onChange={e => setSearch(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') searchTranslations(search, 1);
          }}
          size="small" 
          sx={{ minWidth: 200 }} 
        />
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel>Filter Type</InputLabel>
          <Select value={filterType} label="Filter Type" onChange={e => {
            searchTranslations(undefined, 1, undefined, undefined, undefined, undefined, e.target.value);
          }}>
            <MenuItem key={'all'} value={'all'}>All</MenuItem>
            <MenuItem key={'keyonly'} value={'keyonly'}>Key Only</MenuItem>
            <MenuItem key={'keyandlang1'} value={'keyandlang1'}>Key and Language 1</MenuItem>
            <MenuItem key={'keyandlang2'} value={'keyandlang2'}>Key and Language 2</MenuItem>
          </Select>
        </FormControl>
        {/* State Dropdown */}
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel>State</InputLabel>
          <Select
            value={stateFilterType}
            label="State"
            onChange={e => {
              // You may want to add a new state filter variable, but for now, reuse filterType for demonstration
              searchTranslations(undefined, 1, undefined, undefined, undefined, undefined, undefined, e.target.value);
            }}
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="draft">Draft</MenuItem>
            <MenuItem value="published">Published</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel>Language 1</InputLabel>
          <Select value={lang1} label="Language 1" onChange={e => {
            searchTranslations(undefined, 1, undefined, e.target.value);
          }}>
            {languages.map(l => <MenuItem key={l.id} value={l.id}>{l.name}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel>Language 2</InputLabel>
          <Select value={lang2} label="Language 2" onChange={e => {
            searchTranslations(undefined, 1, undefined, undefined, e.target.value);
          }}>
            {languages.map(l => <MenuItem key={l.id} value={l.id}>{l.name}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControlLabel
          control={<Checkbox checked={showMissingLang2} onChange={e => searchTranslations(undefined, 1, undefined, undefined, undefined, e.target.checked)} />}
          label={`Only show missing ${languages.find(l => l.id === lang2)?.name || lang2} translations`}
          sx={{ ml: 2 }}
        />
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => setShowAddRow(true)}>Add</Button>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1, justifyContent: 'flex-end' }}>
        <TextField
          label="Page Size"
          type="number"
          size="small"
          sx={{ width: 100 }}
          value={pageSize}
          onChange={e => { 
            setPageSize(Number(e.target.value));
            searchTranslations(undefined, 1, Number(e.target.value));
          }}
        />
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          {currentPage > 1 && (
            <IconButton
              onClick={() => searchTranslations(undefined, 1)}
              size="large"
            >
              <FirstPageIcon />
            </IconButton>
          )}
          <IconButton
            disabled={currentPage === 1}
            onClick={() => searchTranslations(undefined, currentPage - 1)}
            size="large"
          >
            <ChevronLeftIcon />
          </IconButton>
          <IconButton
            disabled={!hasMoreResults}
            onClick={() => searchTranslations(undefined, currentPage + 1)}
            size="large"
          >
            <ChevronRightIcon />
          </IconButton>
          <span style={{ alignSelf: 'center', minWidth: 80, textAlign: 'center' }}>
            Page {currentPage}
          </span>
        </Box>
      </Box>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Key</TableCell>
              <TableCell>{languages.find(l => l.id === lang1)?.name || lang1}</TableCell>
              <TableCell>{languages.find(l => l.id === lang2)?.name || lang2}</TableCell>
              <TableCell align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {showAddRow && (
              <TableRow>
                <TableCell>
                  <TextField
                    label="Key"
                    value={newKey}
                    onChange={e => setNewKey(e.target.value.replace(/\s+/g, '.').replace(/\.+/g, '.'))}
                    size="small"
                    fullWidth
                    inputRef={addKeyInputRef}
                    onKeyDown={e => {
                      if (e.key === 'Enter') handleAdd();
                      if (e.key === 'Escape') setShowAddRow(false);
                    }}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    label={languages.find(l => l.id === lang1)?.name || lang1}
                    value={newValues[lang1] || ''}
                    onChange={e => setNewValues({ ...newValues, [lang1]: e.target.value })}
                    size="small"
                    fullWidth
                    onKeyDown={e => {
                      if (e.key === 'Enter') handleAdd();
                      if (e.key === 'Escape') setShowAddRow(false);
                    }}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    label={languages.find(l => l.id === lang2)?.name || lang2}
                    value={newValues[lang2] || ''}
                    onChange={e => setNewValues({ ...newValues, [lang2]: e.target.value })}
                    size="small"
                    fullWidth
                    onKeyDown={e => {
                      if (e.key === 'Enter') handleAdd();
                      if (e.key === 'Escape') setShowAddRow(false);
                    }}
                  />
                </TableCell>
                <TableCell align="right">
                  <Button variant="contained" size="small" sx={{ mr: 1 }} onClick={handleAdd}>Add</Button>
                  <Button variant="outlined" size="small" onClick={() => setShowAddRow(false)}>Cancel</Button>
                </TableCell>
              </TableRow>
            )}
            {translations.keys.map(t => (
              <TableRow key={t.key}>
                <TableCell>{t.key}</TableCell>
                <TableCell>
                  {editKey?.key === t.key ? (
                    <TextField
                      value={editKey.language1Value.value}
                      onChange={e => setEditKey({ ...editKey, language1Value: { ...editKey.language1Value, value: e.target.value } })}
                      size="small"
                      inputRef={lang1InputRef}
                      onFocus={() => { lastEditFocusRef.current = 'lang1'; }}
                      onKeyDown={e => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                          handleEditSave();
                          e.preventDefault();
                        }
                        if (e.key === 'Escape') handleEditCancel();
                      }}
                      multiline={editKey.language1Value.value.length > 40}
                      minRows={editKey.language1Value.value.length > 40 ? 3 : 1}
                      fullWidth
                    />
                  ) : (
                    <Box title={t.publishedValue1 ? `Published: ${t.publishedValue1}` : ''} sx={{ cursor: t.publishedValue1 ? 'pointer' : 'default' }}>
                      {t.value1}
                    </Box>
                  )}
                </TableCell>
                <TableCell>
                  {editKey?.key === t.key ? (
                    <TextField
                      value={editKey.language2Value.value}
                      onChange={e => setEditKey({ ...editKey, language2Value: { ...editKey.language2Value, value: e.target.value } })}
                      size="small"
                      inputRef={lang2InputRef}
                      onFocus={() => { lastEditFocusRef.current = 'lang2'; }}
                      onKeyDown={e => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                          handleEditSave();
                          e.preventDefault();
                        }
                        if (e.key === 'Escape') handleEditCancel();
                      }}
                      multiline={editKey.language2Value.value.length > 40}
                      minRows={editKey.language2Value.value.length > 40 ? 3 : 1}
                      fullWidth
                    />
                  ) : (
                    <Box title={t.publishedValue2 ? `Published: ${t.publishedValue2}` : ''} sx={{ cursor: t.publishedValue2 ? 'pointer' : 'default' }}>
                      {t.value2}
                    </Box>
                  )}
                </TableCell>
                <TableCell align="right">
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%', justifyContent: 'flex-end' }}>
                    {/* State Badge */}
                    <Chip key={t.key + t.stateType} label={t.stateType === 'draft' ? "Draft": "Published"} color={t.stateType === 'draft' ? "default" : "success"} size="small" />
                    {editKey?.key === t.key ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Button variant="contained" size="small" onClick={handleEditSave}>Save</Button>
                        <Button variant="outlined" size="small" onClick={handleEditCancel}>Cancel</Button>
                      </Box>
                    ) : (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {t.stateType === 'draft' && (
                          <>
                            {t.lastPublishedAt && (
                              <IconButton size="small" color="warning" title="Revert" onClick={() => revertChanges(t.key)}>
                                <ReplayIcon fontSize="small" />
                              </IconButton>
                            )}
                            <IconButton size="small" color="primary" title="Publish" onClick={() => publishChanges(t.key)}>
                              <PublishIcon fontSize="small" />
                            </IconButton>
                          </>
                        )}
                        <IconButton size="small" onClick={() => handleEdit({ key: t.key, language1Value: { languageId: lang1, value: t.value1 }, language2Value: { languageId: lang2, value: t.value2 } })}><EditIcon fontSize="small" /></IconButton>
                        <IconButton size="small" onClick={() => setConfirmDeleteKey(t.key)}><DeleteIcon fontSize="small" /></IconButton>
                      </Box>
                    )}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    {/* Confirmation Dialog for Deletion */}
    <Dialog open={!!confirmDeleteKey} onClose={() => setConfirmDeleteKey(null)}>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete the translation key "{confirmDeleteKey}"? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setConfirmDeleteKey(null)} color="primary">
          Cancel
        </Button>
        <Button onClick={() => confirmDeleteKey && handleDelete(confirmDeleteKey)} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
};

export default TranslationsView;
